import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import materialDeliveryListAction from './materialDeliveryList.action.json' with { type: 'json' }
import { materialDeliveryObject } from '../materialDeliveryObject'
import { materialObject } from '../../material/materialObject'

export const materialDeliveryExpression = expression(materialDeliveryObject.shape)

const materialDeliveryListDefinition = defineAction({
  ...materialDeliveryListAction,
  input: z.object({
    filter: materialDeliveryExpression.nullish(),
    citizenId: z.string().uuid().nullish(),
    startDate: z.string().nullish(),
    endDate: z.string().nullish(),
    materialId: materialObject.shape.id.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      deliveryDate: 'Data da entrega',
      protocolCode: 'Protocolo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(materialDeliveryObject),
    count: z.number(),
  }),
})

export default materialDeliveryListDefinition
